import React from 'react';
import { classes } from 'typestyle';
import { dialogSection } from './Dialog.styles';

export function DialogBody({ className, ...props }: React.DialogHTMLAttributes<HTMLDivElement>) {
  return <div className={classes(dialogSection, className)} {...props} />;
}
